import { render, staticRenderFns } from "./videoRecorder.vue?vue&type=template&id=6b7edef2&scoped=true&"
import script from "./videoRecorder.vue?vue&type=script&lang=js&"
export * from "./videoRecorder.vue?vue&type=script&lang=js&"
import style0 from "./videoRecorder.vue?vue&type=style&index=0&id=6b7edef2&scoped=true&lang=scss&"
import style1 from "./videoRecorder.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7edef2",
  null
  
)

export default component.exports